var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Matrix2',{attrs:{"egress_profile_id":_vm.egress_profile_id,"allows_crud":_vm.allows_crud,"isBusy":_vm.isBusy,"courses_wrapper_id":_vm.courses_wrapper_id}}),_c('MeshCustomFab',{staticClass:"noprint",attrs:{"egress_profile_id":_vm.egress_profile_id,"show_matrix2":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }